import React, { useState, useEffect } from 'react';

const PreviewTerminal = ({ command, toolName, description }) => {
  const [previewText, setPreviewText] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  // Handle command preview typing animation
  useEffect(() => {
    if (!command) {
      setPreviewText('');
      setIsTyping(false);
      return;
    }

    setIsTyping(true);
    setPreviewText('');
    
    let currentIndex = 0;
    const typingSpeed = 30; // milliseconds per character
    
    const typingInterval = setInterval(() => {
      if (currentIndex < command.length) {
        setPreviewText(command.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(typingInterval);
      }
    }, typingSpeed);

    return () => clearInterval(typingInterval);
  }, [command]);

  return (
    <div style={{ 
      height: '100%', 
      background: '#0a0014', 
      color: '#00ff41', 
      fontFamily: '"JetBrains Mono", "Fira Code", "Consolas", "Courier New", monospace', 
      padding: '15px', 
      overflowY: 'auto',
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      {/* Header */}
      <div style={{
        borderBottom: '2px solid rgba(6, 182, 212, 0.3)',
        paddingBottom: '10px'
      }}>
        <div style={{
          fontSize: '12px',
          color: '#06b6d4',
          fontWeight: '700',
          letterSpacing: '1px',
          marginBottom: '8px'
        }}>
          💡 COMMAND DEMONSTRATION
        </div>
        {toolName && (
          <div style={{
            fontSize: '11px',
            color: '#94a3b8',
            fontStyle: 'italic'
          }}>
            Showing practical usage of: <span style={{ color: '#06b6d4', fontWeight: '600' }}>{toolName}</span>
          </div>
        )}
      </div>

      {/* Welcome Message */}
      <div style={{
        color: '#64748b',
        fontSize: '12px',
        lineHeight: '1.6'
      }}>
        <div>Demo Terminal [Read-Only Mode]</div>
        <div style={{ marginTop: '4px', color: '#475569' }}>
          Hover over different tools in the About Me section to see example commands
        </div>
      </div>

      {/* Command Preview Box */}
      {previewText && (
        <div style={{ 
          padding: '12px',
          background: 'rgba(6, 182, 212, 0.08)',
          border: '1px solid rgba(6, 182, 212, 0.3)',
          borderRadius: '6px',
          borderLeft: '4px solid #06b6d4'
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <span style={{ 
              color: '#06b6d4', 
              fontWeight: '700',
              flexShrink: 0 
            }}>
              demo@preview
            </span>
            <span style={{ 
              color: '#b026ff', 
              fontWeight: 500,
              flexShrink: 0 
            }}>
              $
            </span>
            <span style={{ 
              color: '#06b6d4', 
              fontFamily: 'inherit',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
              flex: 1
            }}>
              {previewText}
              {isTyping && (
                <span style={{ 
                  animation: 'blink 1s infinite',
                  marginLeft: '2px'
                }}>
                  ▊
                </span>
              )}
            </span>
          </div>
        </div>
      )}

      {/* What This Command Does */}
      {description && (
        <div style={{
          padding: '12px',
          background: 'rgba(16, 185, 129, 0.05)',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          borderRadius: '6px',
          borderLeft: '4px solid #10b981'
        }}>
          <div style={{
            fontSize: '10px',
            color: '#10b981',
            fontWeight: '700',
            marginBottom: '8px',
            letterSpacing: '0.5px',
            textTransform: 'uppercase'
          }}>
            📚 What This Command Does
          </div>
          <div style={{
            fontSize: '12px',
            color: '#cbd5e1',
            lineHeight: '1.6'
          }}>
            {description}
          </div>
        </div>
      )}

      {/* Info Footer */}
      <div style={{
        marginTop: 'auto',
        paddingTop: '12px',
        borderTop: '1px solid rgba(74, 158, 255, 0.2)',
        fontSize: '10px',
        color: '#475569',
        textAlign: 'center'
      }}>
        This is a demonstration terminal showing real-world command examples
      </div>

      <style>{`
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default PreviewTerminal;
